import getToDesktopPackageJson from './getToDesktopPackageJson';

const cliVersion = getToDesktopPackageJson().version;

export default function getCliVersion(): string {
  return cliVersion;
}
